import { render, staticRenderFns } from "./financialSummaryAccount.vue?vue&type=template&id=bbd2a344&scoped=true"
import script from "./financialSummaryAccount.vue?vue&type=script&lang=js"
export * from "./financialSummaryAccount.vue?vue&type=script&lang=js"
import style0 from "./financialSummaryAccount.vue?vue&type=style&index=0&id=bbd2a344&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd2a344",
  null
  
)

export default component.exports